export default "__VITE_ASSET__DsKPQJ7b__"